"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationsItemSetListDto = void 0;
const tslib_1 = require("tslib");
const swagger_v4_1 = require("@nestjs/swagger-v4");
const class_transformer_1 = require("class-transformer");
const common_1 = require("@goparrot/common");
const class_validator_1 = require("class-validator");
class LocationsItemSetListDto {
}
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => String, isArray: true, example: ['60dad945-ab24-4cc8-b8ff-fd553e7c33c4'], uniqueItems: true }),
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.UPDATE] }),
    (0, class_validator_1.IsArray)({ always: true }),
    (0, class_validator_1.ArrayUnique)({ always: true }),
    (0, class_validator_1.IsString)({ always: true, each: true }),
    tslib_1.__metadata("design:type", Array)
], LocationsItemSetListDto.prototype, "itemSetIds", void 0);
tslib_1.__decorate([
    (0, swagger_v4_1.ApiPropertyOptional)({ type: () => String, isArray: true, example: ['60dad945-ab24-4cc8-b8ff-fd553e7c33c4'], uniqueItems: true }),
    (0, class_transformer_1.Expose)({ groups: [common_1.DefaultExposeGroupEnum.UPDATE] }),
    (0, class_validator_1.IsArray)({ always: true }),
    (0, class_validator_1.ArrayUnique)({ always: true }),
    (0, class_validator_1.IsString)({ always: true, each: true }),
    tslib_1.__metadata("design:type", Array)
], LocationsItemSetListDto.prototype, "locationIds", void 0);
exports.LocationsItemSetListDto = LocationsItemSetListDto;
//# sourceMappingURL=LocationsItemSetListDto.js.map